export default {
  'app.settings.menuMap.basic': '기본 설정',
  'app.settings.menuMap.security': '보안 설정',
  'app.settings.menuMap.binding': '계정 연동',
  'app.settings.menuMap.notification': '새 메시지 알림',
  'app.settings.basic.avatar': '아바타',
  'app.settings.basic.change-avatar': '아바타 변경',
  'app.settings.basic.email': '이메일',
  'app.settings.basic.email-message': '이메일을 입력해주세요!',
  'app.settings.basic.nickname': '닉네임',
  'app.settings.basic.nickname-message': '닉네임을 입력해주세요!',
  'app.settings.basic.profile': '개인 프로필',
  'app.settings.basic.profile-message': '개인 프로필을 입력해주세요!',
  'app.settings.basic.profile-placeholder': '자기소개를 간단히 작성해주세요',
  'app.settings.basic.country': '국가/지역',
  'app.settings.basic.country-message': '국가를 입력해주세요!',
  'app.settings.basic.geographic': '시/도 또는 도시',
  'app.settings.basic.geographic-message': '지역 정보를 입력해주세요!',
  'app.settings.basic.address': '주소',
  'app.settings.basic.address-message': '주소를 입력해주세요!',
  'app.settings.basic.phone': '전화번호',
  'app.settings.basic.phone-message': '전화번호를 입력해주세요!',
  'app.settings.basic.update': '정보 업데이트',
  'app.settings.security.strong': '강함',
  'app.settings.security.medium': '보통',
  'app.settings.security.weak': '약함',
  'app.settings.security.password': '계정 비밀번호',
  'app.settings.security.password-description': '현재 비밀번호 강도',
  'app.settings.security.phone': '보안 전화',
  'app.settings.security.phone-description': '연동된 전화번호',
  'app.settings.security.question': '보안 질문',
  'app.settings.security.question-description':
    '보안 질문이 설정되지 않았습니다. 보안 정책으로 계정 보안을 효과적으로 보호할 수 있습니다',
  'app.settings.security.email': '백업 이메일',
  'app.settings.security.email-description': '연동된 이메일',
  'app.settings.security.mfa': 'MFA 장치',
  'app.settings.security.mfa-description':
    '연동되지 않은 MFA 장치, 연동 후 이중 확인이 가능합니다',
  'app.settings.security.modify': '수정',
  'app.settings.security.set': '설정',
  'app.settings.security.bind': '연동',
  'app.settings.binding.taobao': 'Taobao 연동',
  'app.settings.binding.taobao-description': '현재 연동되지 않은 Taobao 계정',
  'app.settings.binding.alipay': 'Alipay 연동',
  'app.settings.binding.alipay-description': '현재 연동되지 않은 Alipay 계정',
  'app.settings.binding.dingding': 'DingTalk 연동',
  'app.settings.binding.dingding-description':
    '현재 연동되지 않은 DingTalk 계정',
  'app.settings.binding.bind': '연동',
  'app.settings.notification.password': '계정 비밀번호',
  'app.settings.notification.password-description':
    '다른 사용자의 메시지는 스테이션 레터 형태로 알림됩니다',
  'app.settings.notification.messages': '시스템 메시지',
  'app.settings.notification.messages-description':
    '시스템 메시지는 스테이션 레터 형태로 알림됩니다',
  'app.settings.notification.todo': '할 일 알림',
  'app.settings.notification.todo-description':
    '할 일 목록은 스테이션 레터 형태로 알림됩니다',
  'app.settings.open': '열기',
  'app.settings.close': '닫기',
};